import { Dialog } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/ClearOutlined'
import { IconButton, Tooltip } from 'opensolar-ui'
import PropTypes from 'prop-types'
import { useTranslate } from 'react-admin'

const ImageDialog = ({ isOpen = false, closeDialog, src, title = null }) => {
  const translate = useTranslate()
  return (
    <div>
      <Dialog open={isOpen} onBackdropClick={() => closeDialog()}>
        <IconButton
          id="EditUsageClose"
          style={{
            top: 10,
            right: 10,
            position: 'absolute',
            minWidth: 40,
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
          }}
          onClick={() => closeDialog()}
        >
          {
            <Tooltip title={translate('Close Dialog')} enterDelay={300}>
              <CloseIcon style={{ color: '#000000' }} />
            </Tooltip>
          }
        </IconButton>

        {title && <h1 style={{ marginTop: 0 }}>{title}</h1>}
        <img style={{ width: '100%' }} src={src} />
      </Dialog>
    </div>
  )
}

ImageDialog.propTypes = {
  isOpen: PropTypes.bool,
  closeDialog: PropTypes.func.isRequired,
  src: PropTypes.string,
  title: PropTypes.string,
}

export default ImageDialog
